/*
 * @Author: 吴文洁
 * @Date: 2020-01-29 09:58:24
 * @LastEditors  : 吴文洁
 * @LastEditTime : 2020-01-29 10:17:18
 * @Description: 直播课次
 */

export default {
  routes: [{
    path: '/live/list',
    name: 'live_list',
    component: () => import('@/module/live/LiveListPage.vue'),
    meta: {
      title: '直播课次列表',
      keepAlive: true,
      logined: true
    }
  }, {
    path: '/live/detail',
    name: 'live_detail',
    component: () => import('@/module/live/LiveDetailPage.vue'),
    meta: {
      title: '直播课次详情',
      keepAlive: false,
      logined: true
    }
  }, {
    path: '/live/report',
    name: 'live_report',
    component: () => import('@/module/live/LiveReportPage.vue'),
    meta: {
      title: '课堂报告',
      keepAlive: false,
      logined: false
    }
  },
  {
    path: '/live/cloud-class-report',
    name: 'live_cloud-class-report',
    component: () => import('@/module/live/ClassReportMobilePage.vue'),
    meta: {
      title: '课堂报告',
      keepAlive: false,
      logined: false
    }
  },
  {
    path: '/live/pc-cloud-class-report',
    name: 'live_pc_cloud-class-report',
    component: () => import('@/module/live/CloudClassLiveReportPage.vue'),
    meta: {
      title: '课堂报告',
      keepAlive: false,
      logined: false
    }
  },
   {
    path: '/live/page',
    name: 'live_page',
    component: () => import('@/module/live/XMLivePage.vue'),
    meta: {
      title: '小麦直播',
      keepAlive: false,
      logined: true
    }
  }, {
    path: '/xm/live/page',
    name: 'xm_live_page',
    component: () => import('@/module/live/XiaomaiLivePage.vue'),
    meta: {
      keepAlive: false,
      logined: true
    }
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/live.js